document.addEventListener("DOMContentLoaded", function () {

	const lightbox = document.getElementById("media-lightbox");
	const lightboxMedia = document.getElementById("lightbox-media");
	const closeBtn = document.querySelector(".close-lightbox");
	const prevBtn = document.querySelector(".prev-lightbox");
	const nextBtn = document.querySelector(".next-lightbox");

	let galleryItems = [];
	let currentIndex = 0;

	function collectGalleryItems() {
		galleryItems = Array.from(document.querySelectorAll("a.ltbx")).map((item) => ({
			type: item.getAttribute("data-lightbox-type"),
			url: item.getAttribute("href"),
			title: item.getAttribute("data-title"),
			text: item.getAttribute("data-text"),
			element: item
		}));
	}

	function openLightbox(item) {
		if (!item) return;
		lightboxMedia.innerHTML = "";

		let mediaContent = "";
		if (item.type === "video") {
			if (item.url.includes(".mp4")) {
				mediaContent = `
					<video controls autoplay>
						<source src="${item.url}" type="video/mp4">
						Your browser does not support the video tag.
					</video>`;
			} else {
				mediaContent = `
					<iframe src="${item.url}" frameborder="0" allowfullscreen></iframe>`;
			}
		} else {
			mediaContent = `<img src="${item.url}" alt="Lightbox Image">`;
		}

		// Add title & text
		const titleText = item.title || "";
		const descText = item.text || "";
		let textContent = (titleText || descText) ? `
			<div class="lightbox-caption">
				<h3>${titleText}</h3>
				<p>${descText}</p>
			</div>` : "";

		lightboxMedia.innerHTML = mediaContent + textContent;
		lightbox.style.display = "flex";
	}

	document.body.addEventListener("click", function (event) {
		let clickedElement = event.target.closest("a.ltbx");
		if (clickedElement) {
			event.preventDefault();
			collectGalleryItems();
			currentIndex = galleryItems.findIndex(item => item.element === clickedElement);
			openLightbox(galleryItems[currentIndex]);
		}
	});

	function closeLightbox() {
		lightbox.style.display = "none";
		lightboxMedia.innerHTML = "";
	}

	function showPrev() {
		currentIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
		openLightbox(galleryItems[currentIndex]);
	}

	function showNext() {
		currentIndex = (currentIndex + 1) % galleryItems.length;
		openLightbox(galleryItems[currentIndex]);
	}

	closeBtn.addEventListener("click", closeLightbox);
	prevBtn.addEventListener("click", showPrev);
	nextBtn.addEventListener("click", showNext);

	lightbox.addEventListener("click", function (event) {
		if (event.target === lightbox) {
			closeLightbox();
		}
	});
});